import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

import { bulkOperator as _bulkOperator } from '@etoh/cdk/rxjs';
import { Observable } from 'rxjs';
import { ProgressSnackbarComponent } from './progress/progress-snackbar/progress-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class RxjsOperatorsService {
  constructor(private _snackBar: MatSnackBar) {}

  bulkOperator<T>(
    arrayOfObservable: Observable<T>[],
    parallel = true, // Default is parallel execution
    concurrency = 15 // Limit concurrency if needed
  ): Observable<T[]> {
    let snackbar: MatSnackBarRef<any> | undefined;

    return _bulkOperator<T>(
      arrayOfObservable,
      (index, length) => {
        if (length < 2) {
          return;
        }

        if (!snackbar) {
          snackbar = this._snackBar.openFromComponent(
            ProgressSnackbarComponent,
            {
              data: {
                message: this.getLoadingMessage(index, length),
              },
              duration: 0,
            }
          );
        } else {
          snackbar.instance.data = {
            message: this.getLoadingMessage(index, length),
          };
        }

        if (index === length) {
          setTimeout(() => {
            snackbar?.dismiss();
          }, 900);
          return;
        }
      },
      parallel,
      concurrency
    );
  }

  private getLoadingMessage(index: number, length: number): string {
    return `Bulk action in progress: ${index}/${length}`;
  }
}
